import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=536711d3&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=536711d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536711d3",
  null
  
)

export default component.exports